import * as Mod1 from "./discourse/components/communiteq-admin-notice";
import * as Mod2 from "./discourse/components/show-backup-info";
import * as Mod3 from "./discourse/connectors/admin-below-plugins-index/discoursehosting.gjs";
import * as Mod4 from "./discourse/connectors/before-backup-list/discoursehosting.gjs";
import * as Mod5 from "./discourse/connectors/below-site-header/show-admin-notice.gjs";
const compatModules = {
  "discourse/components/communiteq-admin-notice": Mod1,
  "discourse/components/show-backup-info": Mod2,
  "discourse/connectors/admin-below-plugins-index/discoursehosting": Mod3,
  "discourse/connectors/before-backup-list/discoursehosting": Mod4,
  "discourse/connectors/below-site-header/show-admin-notice": Mod5,
};
export default compatModules;
